/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmVectorStoresCreateFile } from "../../funcs/llmVectorStoresCreateFile.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.CreateVectorStoreFileRequest$inboundSchema,
};

export const tool$llmVectorStoresCreateFile: ToolDefinition<typeof args> = {
  name: "llm-vector-stores-create-file",
  description: `Add a file to a vector store

Adds a file to a vector store for semantic search indexing.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmVectorStoresCreateFile(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
